package com.esoris.kmpmoout.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.esoris.kmpmoout.features.expense.expense_form.ExpenseFormRoute
import com.esoris.kmpmoout.features.expense.expense_form.ExpenseFormScreen
import com.esoris.kmpmoout.features.product.ProductRoute
import com.esoris.kmpmoout.features.product.ProductScreen
import org.koin.compose.koinInject

@Composable
fun AppNavHost() {

    val navManager = koinInject<NavManager>()

    val backStack by navManager.backStack.collectAsState()

    when (val route = backStack.last()) {

        is ProductRoute -> {
            ProductScreen()
        }

        is ExpenseFormRoute -> {
            ExpenseFormScreen()
        }

//        is ProductDetailRoute -> {
//            ProductDetailScreen(
//                productId = route.productId
//            )
//        }
    }
}